export default function () {
  return {
    item: {},
    items: [],
    pagination: {},
    token: null,
    wsItem: {},
    me: {}
  }
}
